import React, { useEffect, useState } from 'react';
import CommonIcon from './customicon';

const Error = ({ message }) => {
  
// <!--<small class="text-muted">Dec 15, 2024 09:07</small>-->
//   <!--<div class="mt-2">
//   <p class="mb-1"><strong>Code:</strong> DB_001</p>
//   <p class="mb-1">Unable to establish connection with the primary database server</p>
//   <p class="mb-0"><strong>Source:</strong> Database Service</p>
// </div>-->
  return (
    <div class="">
    <div class="alert alert-danger d-flex align-items-start p-1 rounded-3 shadow-sm" role="alert">
        <div class="me-2">
            <i class="bi bi-x-circle-fill text-danger fs-5"></i>
        </div>
        <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-center">
              <strong>  <CommonIcon iconName="CircleX" size={"20px"} color="#cc563d" /> {message} </strong>
            </div>
        </div>
    </div>
</div>

  );
};

export default Error;
